<template>
  <progress
    class="s-circular-loading"
    :removeRightBorderRadius="true"
    :style="loadingStyle"
  />
</template>

<script>
import "@/assets/css/components/base/circular-loading.css";
export default {
  name: "SLoading",
  props: {
    size: {
      default: 30,
      require: true,
    },
    variant: {
      type: String,
      require: true,
      default: "white",
    },
  },
  computed: {
    loadingStyle() {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`,
        color: `var(--${this.variant}-color)`,
      };
    },
  },
};
</script>

<style scoped></style>
